// extracted by mini-css-extract-plugin
module.exports = {"helpText":"_3sQuv","bgPrimary":"iehqj","bgDanger":"_39dDd","textDefault":"KC0WS","textPrimary":"_3pz6c","textDanger":"_2K682"};